var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9254 10.6132V12.6132C13.9262 12.7989 13.8882 12.9827 13.8138 13.1528C13.7394 13.3229 13.6303 13.4756 13.4935 13.6011C13.3567 13.7267 13.1951 13.8222 13.0193 13.8817C12.8434 13.9412 12.657 13.9633 12.4721 13.9466C10.4207 13.7237 8.4501 13.0227 6.71876 11.8999C5.10798 10.8763 3.74232 9.51068 2.71877 7.8999C1.59208 6.16071 0.890927 4.18056 0.672098 2.1199C0.655438 1.93555 0.677348 1.74974 0.736432 1.57432C0.795515 1.39889 0.890479 1.23769 1.01528 1.10098C1.14007 0.964271 1.29197 0.855041 1.46129 0.78025C1.63062 0.705458 1.81366 0.666743 1.99877 0.666569H3.99877C4.3223 0.663384 4.63596 0.777954 4.88127 0.988924C5.12659 1.19989 5.28682 1.49287 5.3321 1.81324C5.41651 2.45328 5.57306 3.08172 5.79877 3.68657C5.88846 3.92518 5.90787 4.18451 5.8547 4.43382C5.80153 4.68313 5.67801 4.91198 5.49876 5.09324L4.6521 5.9399C5.60114 7.60893 6.98307 8.99087 8.6521 9.9399L9.49876 9.09324C9.68002 8.91399 9.90887 8.79047 10.1582 8.7373C10.4075 8.68413 10.6668 8.70354 10.9054 8.79324C11.5103 9.01894 12.1387 9.17549 12.7788 9.2599C13.1026 9.30559 13.3984 9.46871 13.6098 9.71823C13.8212 9.96776 13.9335 10.2863 13.9254 10.6132Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.847d8e55ec59c9701eb9efd437518041.svg";
export { ForwardRef as ReactComponent };